<template>
  <div class="tblx">
    <div :style="{width:offsetWidth()}" class="switchTab">
      <p v-for="item in switchList" :key="item.childId" :class="activeKey===item.childId?'activeClass':''"
         @click="headlerClick(item)">{{ item.childName }}</p>
    </div>
    <div class="tab-clip"></div>
  </div>
</template>
<script>
export default {
  name: 'switchTab',
  data() {
    return {
      activeKey: this.activeIs
    }
  },
  watch: {
    switchList: {
      handler(newValue) {
        if (newValue.length && !this.activeIs) {
          if (this.$route.query.planetTag) {
            this.activeKey = this.$route.query.planetTag * 1
          } else {
            this.activeKey = newValue[0].childId || 0
          }
        }
      }
    },
  },
  props: {
    switchList: {
      type: Array,
      require: true
    },
    activeIs: {
      type: Number,
    }
  },
  methods: {
    headlerClick(item) {
      this.activeKey = item.childId
      this.$emit('headlerClick', item)
    },
    offsetWidth() {
      // 14 :字体大小    12 :左右margin 的大小   16：左右padding的大小
      const width = this.switchList && this.switchList.reduce((pre, cur) => {
        return pre += cur.childName.toString().length * 14 + 12 + 16 + 20
      }, 0) || 0
      return width && `${width}px`
    },
    headlerActive(data) {
      this.$route.query.planetTag = data

    }
  }
}
</script>
<style lang="less" scoped>
.tblx::-webkit-scrollbar {
  display: none
}

.tblx {
  width: 100%;
  //height: 35px;
  //position: relative;
  //overflow: auto;
  overflow-y: hidden;

  .tab-clip {
    width: 20px;
    height: 40px;
    position: absolute;
    right: 0;
    top: 10px;
    background: #fff;
    display: flex;
    //justify-content: center;
    z-index: 1;
    opacity: .8;
    box-shadow: -5px -5px  20px 6px #fff;
  }
}

.switchTab {
  display: flex;
  flex-direction: row;
  //position: absolute;
  //top: 0;
  //left: 0;
  //overflow: auto;

  p {
    padding: 0 8px;
    height: 30px;
    line-height: 32px;
    margin-left: 12px;
    border-radius: 16px;
    font-size: 14px;
    border: 1px solid rgba(218, 218, 218, .4);
    background: #FBFBFB
  }

  .activeClass {
    background: #FFE6F5;
    color: #F470BE;
    border: none;
  }

}

</style>
